<template>
  <div class="mng-page flex flex-col h-full">
    <div class="mng-page__header flex-shrink-0">
      <div class="mng-page__title-row">
        <h1 class="mng-page__title">Настройки</h1>
      </div>
      <div class="settings-divider"></div>
    </div>
    <div class="settings-container">
      <div
        v-for="(chapter, index) in settingsChapters"
        :key="index"
        class="settings-box"
        @click="openSettings(chapter.route)"
      >
        <div class="settings-box__head">
          <h3>{{ chapter.title }}</h3>
          <svg
            class="settings-box__arrow"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M9 6l6 6-6 6" />
          </svg>
        </div>
        <p>{{ chapter.description }}</p>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Settings",
  data() {
    return {
      settingsChapters: [
        {
          title: "Настройка батчей",
          description: "Вы можете включить и выключить батч",
          route: "batches",
        },
        {
          title: "Загрузить файл",
          description: "Вы можете загрузить файл",
          route: "upload",
        },
        {
          title: "Выгрузить файл",
          description: "Вы можете выгрузить файл",
          route: "unload",
        },
      ],
    };
  },
  methods: {
    openSettings(routeName) {
      this.$router.push({ name: routeName });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/manage-page.scss";

.settings-divider {
  margin-top: 18px;
  border-bottom: 1px solid var(--border);
}

.settings-container {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  padding: 22px 26px;
}

.settings-box {
  width: 360px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
  padding: 16px 18px;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease,
    transform 0.15s ease, background-color 0.15s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: var(--border-strong);
    background: var(--accent);
  }

  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  &__arrow {
    width: 16px;
    height: 16px;
    color: var(--muted-foreground);
    flex-shrink: 0;
  }

  h3 {
    font-size: 15px;
    font-weight: 600;
    color: var(--foreground);
    margin: 0;
  }
  p {
    margin: 10px 0 0;
    font-size: 13px;
    line-height: 1.5;
    color: var(--muted-foreground);
  }
}
</style>
